export default {
  notification: null,
  loader: false,
}
